export default __webpack_public_path__ + "static/media/master-card.6f28da03.jpg";